
import { Address } from './types'
import { sortBy } from 'lodash-es'

export interface MattersuiteViewerResponse {
    userDetails?: UserDetails
    businessList?: BusinessList[]
}

export interface BusinessList extends Company {
    // authToken?: string
}

interface Company {
    displayName?: string
    title?: string
    description?: string
    gallery?: string
    profession?: string
    taxId?: string
    website?: string
    preference?: Preference
    source?: string
    medium?: string
    campaign?: string
    primaryEmail?: string
    secondaryEmails?: null
    primaryPhone?: string
    secondaryPhones?: null
    addressCountry?: string
    addressLatitude?: number
    addressLocality?: string
    addressLongitude?: number
    addressPostalCode?: string
    addressRegion?: string
    addressStreetAddress?: string
    apps?: WizardPosition[]
    // activeApps?: Array<string>
    // disableApps?: Array<string>
    companySettings?: WizardPosition
    subscriptionDetails?: any
    locations?: Location[]
    slug?: WizardPosition
    id?: string
    parent?: string
    isActive?: boolean
    metadata?: string
    isDeleted?: null
    deletedBy?: null
    deletedOn?: null
    updatedBy?: null
    updatedOn?: string
    createdBy?: null
    createdOn?: string
    userRoles?: UserRole
    roleLevel?: 'com' | 'loc'
    userRoleForRegistration?: UserRoleForRegistration
    employeeDetails?: EmployeeDetails
    contactDetails?: ContactDetails
    isDefaultData?: boolean
}
export interface ContactDetails {
    contactType?: number
    companyName?: string
    companyId?: string
    contactPrefix?: string
    initial?: string
    firstName?: string
    middleName?: string
    lastName?: string
    employee?: string
    primaryEmail?: string
    email?: Email[]
    phone?: Phone[]
    website?: Website[]
    address?: Address[]
    timezone?: string
    oldCustomFieldSetAssociation?: string
    profileImageThumbImage?: string
    profileImageLargeImage?: string
    fieldVariableMask?: null
    customFieldSetAssociation?: any[]
    primaryPhone?: string
    isClient?: boolean
    title?: string
    userId?: string
    isExternalCounsel?: boolean
    tags?: null
    matterId?: null
    matterParent?: null
    matterTitle?: null
    matterDescription?: null
    matterNumber?: null
    customFieldValues?: null
    displayCustomFieldList?: null
    displayCustomFieldSetList?: null
    matterContactId?: null
    matterContactIsClient?: null
    matterContactContactRelationId?: null
    matterContactParent?: null
    matterContactFieldVariableMask?: null
    matterContactIsPrimaryClient?: null
    matterContactIsActive?: null
    matterContactIsClientPortalAccess?: null
    contactRelationTitle?: null
    contactCompanyName?: null
    customFields?: null
    id?: string
    parent?: string
    isActive?: boolean
    metadata?: string
    isDeleted?: boolean
    deletedBy?: string
    deletedOn?: string
    updatedBy?: null
    updatedOn?: string
    createdBy?: string
    createdOn?: string
}

export interface Email {
    email?: string
    emailType?: number
    isPrimary?: boolean
}

export interface Phone {
    phone?: string
    phoneType?: number
    isPrimary?: boolean
}

export interface Website {
    website?: string
    websiteType?: number
    isPrimary?: boolean
}

export interface EmployeeDetails {
    firstName?: string
    lastName?: string
    email?: string
    gender?: number
    employeeNumber?: string
    phoneNumber?: string
    departmentId?: string
    designationId?: string
    departmentTitle?: string
    designationName?: string
    hireDate?: string
    userId?: string
    isInvitationAccepted?: boolean
    profileIds?: string[]
    timeZone?: string | null
    hasExtendedProfiles?: boolean
    displayOrder?: number
    disableLogin?: boolean
    profileImageThumbImage?: string
    profileImageLargeImage?: string
    fieldVariableMask?: string
    changedSettings?: any[]
    language?: string | null
    displayLocations?: DisplayLocations[]
    userRoleList?: UserRoleMatterSuite[]
    roleName?: string | null
    preference?: EmployeePreference[] | null
    id?: string
    parent?: string
    isActive?: boolean
    metadata?: Record<string, any>
    isDeleted?: boolean
    deletedBy?: string
    deletedOn?: string
    updatedBy?: string
    updatedOn?: string
    createdBy?: string
    createdOn?: string
}
export interface EmployeePreference {
    id?: string
    color?: string
    title?: string
    selected?: boolean
}
export interface UserRoleMatterSuite {
    userId?: string
    roleId?: string
    locationId?: null
    employeeId?: null
    roleName?: string
    roleLevel?: string
    sysName?: string
    id?: string
    parent?: string
    isActive?: boolean
    metadata?: null
    isDeleted?: boolean
    deletedBy?: string
    deletedOn?: string
    updatedBy?: string
    updatedOn?: string
    createdBy?: string
    createdOn?: string
}
export interface DisplayLocations {
    addressCountry?: string
    addressLatitude?: number
    addressLocality?: string
    addressLongitude?: number
    addressPostalCode?: string
    addressRegion?: string
    addressStreetAddress?: string
    description?: string
    gallery?: {
        default?: {
            thumbImage?: string
            largeImage?: string
        } | null
        images?: {
            largeImage?: string
            thumbImage?: string
        }[]
    }
    name?: string
    preference?: Preference
    slugObject?: SlugObject
    telephones?: string[]
    id?: string
    parent?: string
    isActive?: boolean
    metadata?: Record<string, any>
    isDeleted?: boolean
    userRoles?: UserRoleMatterSuite
    deletedBy?: string
    deletedOn?: string
    updatedBy?: string
    updatedOn?: string
    createdBy?: string
    createdOn?: string
}
export interface SlugObject {
    appTypeId?: string
    name?: string
    serviceModules?: string[]
    id?: string
    parent?: null | string
    isActive?: boolean
    metadata?: null
    isDeleted?: null
    deletedBy?: null
    deletedOn?: null
    updatedBy?: null
    updatedOn?: Date | null
    createdBy?: null
    createdOn?: Date
    navMenus?: string
    licenseName?: string
    slugValue?: string
    slugType?: string
}
export interface UserRoleForRegistration {
    userId?: string
    roleId?: string
    locationId?: null
    employeeId?: null
    roleName?: string
    roleLevel?: string
    sysName?: string
    id?: string
    parent?: string
    isActive?: boolean
    metadata?: null
    isDeleted?: boolean
    deletedBy?: string
    deletedOn?: string
    updatedBy?: string
    updatedOn?: string
    createdBy?: string
    createdOn?: string
}

interface WizardPosition {
    appTypeId?: string
    name?: string
    serviceModules?: string[]
    id?: string
    parent?: null | string
    isActive?: boolean
    metadata?: null
    isDeleted?: null
    deletedBy?: null
    deletedOn?: null
    updatedBy?: null
    updatedOn?: string | null
    createdBy?: null
    createdOn?: string
    navMenus?: string
    licenseName?: string
    slugValue?: string
    slugType?: string
    wizardPosition?: number
    userId?: string
}

interface Location {
    addressCountry?: string
    addressLatitude?: number
    addressLocality?: string
    addressLongitude?: number
    addressPostalCode?: string
    addressRegion?: string
    addressStreetAddress?: string
    description?: string
    gallery?: {
        default?: {
            thumbImage?: string
            largeImage?: string
        } | null
        images?: {
            largeImage?: string
            thumbImage?: string
        }[]
    }
    name?: string
    invoiceCurrency?: { currencyCode?: string | null; currencySymbol?: string | null }
    preference?: Preference
    slugObject?: WizardPosition
    telephones?: string[]
    id?: string
    parent?: string
    isActive?: boolean
    isPrimary?: boolean
    metadata?: Record<string, any>
    isDeleted?: boolean
    userRoles?: UserRole
    deletedBy?: string
    deletedOn?: string
    updatedBy?: string
    updatedOn?: string
    createdBy?: string
    createdOn?: string
}

interface Preference {
    uiInfo?: string | null
    currency?: string | null
    currencySymbol?: string | null
    language?: string | null
    timezone?: string | null
    dateFormat?: string | null
    timeFormat?: string | null
    startOfWeek?: number
    IsProductTourVisited?: boolean
    isWizardVisited?: boolean
    DashboardWidgetSetting?: string
    isNotificationsEnabled?: boolean
}

interface UserDetails {
    name?: null
    firstName?: string
    lastName?: string
    passwordSalt?: null
    passwordHash?: null
    preferences?: Preference
    email?: string
    username?: string
    isContact?: boolean
    forceForPass?: boolean
    twoFactorAuth?: boolean
    isInvitedByAdmin?: null
    profileImageThumbImage?: string
    profileImageLargeImage?: string
    refreshToken?: string
    tokenExpiration?: string
    passwordExpiryOn?: string
    passwordChangedOn?: string
    isPasswordExpired?: boolean
    lastLoginDate?: null
    lastLoginIp?: null
    lastLoginDevice?: null
    resetId?: null
    resetIdExpiryOn?: null
    phoneNumber?: string
    source?: null
    id?: string
    parent?: null
    isActive?: boolean
    metadata?: string
    isDeleted?: null
    deletedBy?: null
    deletedOn?: null
    updatedBy?: null
    updatedOn?: null
    createdBy?: null
    createdOn?: string
    verifiedTelephones?: string[]
    telephones?: string[]
    birthDate?: string
}

interface UserRole {
    parent?: string
    role?: Role
    roles?: Role[]
}

interface Role {
    roleDetails?: RoleDetails
}

interface RoleDetails {
    activeApps?: Array<string>
    disableApps?: Array<string>
    authToken?: string
    description?: null
    appName?: string
    permissionDisplayName?: string
    permissionSystemName?: string
    dependentOn?: string
    priority?: number
    id?: string
    parent?: null | string
    isActive?: boolean
    metadata?: null
    isDeleted?: null
    deletedBy?: null
    deletedOn?: null
    updatedBy?: null
    updatedOn?: string
    createdBy?: null
    createdOn?: string
    roleName?: string
    sysName?: string
    level?: string
    isDefault?: boolean
    permissions?: RoleDetails[]
}

export const parseViewer = <T extends MattersuiteViewerResponse>(viewerInput: T): any => {
    return {
        companies: viewerInput?.businessList?.map((company) => {
            const locations = sortBy(company?.locations, 'createdOn')
            const authToken = company?.userRoles?.roles?.[0]?.roleDetails?.authToken!
            const apps = company?.userRoles?.roles?.[0]?.roleDetails?.activeApps?.map((app) => ({
                active: true,
                name: app,
                isActive: true,
                id: '',
                appTypeId: '',
                serviceModules: [],
            })) ?? []
            return {
                roleLevel: company?.roleLevel!,
                authToken,
                id: company?.id!,
                displayName: company?.displayName!,
                title: company?.title!,
                profession: company?.profession!,
                active: company?.isActive!,
                isActive: company?.isActive!,
                taxId: company?.taxId,
                isDefaultData: company?.isDefaultData,
                userRoleForRegistration: company?.userRoleForRegistration,
                employeeDetails: company?.employeeDetails,
                contactDetails: company?.contactDetails,
                preference: {
                    currency: company?.preference?.currency!,
                    currencySymbol: company?.preference?.currencySymbol!,
                    dateFormat: company?.preference?.dateFormat!,
                    language: company?.preference?.language!,
                    timeFormat: company?.preference?.timeFormat!,
                    timezone: company?.preference?.timezone!,
                    uiInfo: company?.preference?.uiInfo!,
                },
                gallery: company?.gallery as any,
                address: {
                    country: company?.addressCountry!,
                    latitude: company?.addressLatitude!,
                    locality: company?.addressLocality!,
                    longitude: company?.addressLongitude!,
                    postalCode: company?.addressPostalCode!,
                    region: company?.addressRegion!,
                    streetAddress: company?.addressStreetAddress!,
                },
                telephones: [
                    company?.primaryPhone!,
                    ...(company?.secondaryPhones ? [company?.secondaryPhones!] : []),
                ],
                description: company?.description!,
                emails: [
                    company?.primaryEmail!,
                    ...(company?.secondaryEmails ? [company?.secondaryEmails!] : []),
                ],
                apps,
                slugObject: company?.slug!,
                locations: locations?.map((location) => {
                    const authToken = location?.userRoles?.roles?.[0]?.roleDetails?.authToken!
                    const apps = location?.userRoles?.roles?.[0]?.roleDetails?.activeApps?.map((app) => ({
                        active: true,
                        name: app,
                        isActive: true,
                        id: '',
                        appTypeId: '',
                        serviceModules: [],
                    })) ?? []
                    return {
                        id: location?.id!,
                        name: location?.name,
                        invoiceCurrency: {
                            currency: location?.invoiceCurrency?.currencyCode!,
                            currencySymbol: location?.invoiceCurrency?.currencySymbol!
                        }, //Invoice Currency for this location
                        preference: {
                            currency: location?.preference?.currency!,
                            currencySymbol: location?.preference?.currencySymbol!,
                            dateFormat: location?.preference?.dateFormat!,
                            language: location?.preference?.language!,
                            timeFormat: location?.preference?.timeFormat!,
                            timezone: location?.preference?.timezone!,
                            uiInfo: location?.preference?.uiInfo!,
                        },
                        slugObject: {
                            id: location?.slugObject?.id!,
                            slugValue: location?.slugObject?.slugValue!,
                            slugType: location?.slugObject?.slugType!,
                        },
                        gallery: location?.gallery!,
                        address: {
                            country: location?.addressCountry!,
                            latitude: location?.addressLatitude!,
                            locality: location?.addressLocality!,
                            longitude: location?.addressLongitude!,
                            postalCode: location?.addressPostalCode!,
                            region: location?.addressRegion!,
                            streetAddress: location?.addressStreetAddress!,
                        },
                        telephones: [],
                        description: location?.description!,
                        active: location?.isActive!,
                        isPrimary: location?.isPrimary,
                        metadata: location?.metadata! ? location?.metadata! : {},
                        userRoles: {
                            role: location?.userRoles
                                ? location?.userRoles?.roles?.map(role => {
                                    const authToken = role?.roleDetails?.authToken!
                                    const apps = role?.roleDetails?.activeApps?.map((app) => ({
                                        active: true,
                                        name: app,
                                        isActive: true,
                                        id: '',
                                        appTypeId: '',
                                        serviceModules: [],
                                    })) ?? []
                                    return ({
                                        authToken,
                                        apps,
                                        levelDetails: {
                                            id: role?.roleDetails?.parent!,
                                        },
                                        roleId: role?.roleDetails?.id!,
                                        levelId: role?.roleDetails?.parent!,
                                        role: {
                                            id: role?.roleDetails?.id!,
                                            level: role?.roleDetails?.level!,
                                            roleName: role?.roleDetails?.roleName!,
                                            sysName: role?.roleDetails?.sysName!,
                                            isDefault: role?.roleDetails?.isDefault!,
                                            priority: role?.roleDetails?.priority!,
                                            moduleRoles:
                                                role?.roleDetails?.permissions?.map(
                                                    (permission) => ({
                                                        name: permission.permissionSystemName!,
                                                    })
                                                ) ?? [],
                                        },
                                    })
                                })
                                : [],
                        },
                        apps,
                        authToken
                    }
                }),
                companySettings: {
                    ...company?.companySettings!,
                    navMenus: company?.companySettings?.navMenus!
                        ? JSON.parse(company?.companySettings?.navMenus)
                        : [],
                },
                metadata: company?.metadata! ? company?.metadata : {},
                licenseWallet: company?.subscriptionDetails!,
                website: company?.website!,
                userRoles: {
                    role: company?.userRoles
                        ? company?.userRoles?.roles?.map(role => {
                            const authToken = role?.roleDetails?.authToken!
                            const apps = role?.roleDetails?.activeApps?.map((app) => ({
                                active: true,
                                name: app,
                                isActive: true,
                                id: '',
                                appTypeId: '',
                                serviceModules: [],
                            })) ?? []
                            return ({
                                authToken,
                                apps,
                                levelDetails: {
                                    id: role?.roleDetails?.parent!,
                                },
                                roleId: role?.roleDetails?.id!,
                                levelId: role?.roleDetails?.parent!,
                                role: {
                                    id: role?.roleDetails?.id!,
                                    level: role?.roleDetails?.level!,
                                    roleName: role?.roleDetails?.roleName!,
                                    sysName: role?.roleDetails?.sysName!,
                                    isDefault: role?.roleDetails?.isDefault!,
                                    priority: role?.roleDetails?.priority!,
                                    moduleRoles:
                                        role?.roleDetails?.permissions?.map(
                                            (permission) => ({
                                                name: permission.permissionSystemName!,
                                            })
                                        ) ?? [],
                                },
                            })
                        })
                        : [],
                },
            }
        }),
        id: viewerInput?.userDetails?.id!,
        firstName: viewerInput?.userDetails?.firstName!,
        lastName: viewerInput?.userDetails?.lastName!,
        email: viewerInput?.userDetails?.email!,
        profileImage: {
            thumbImage: viewerInput?.userDetails?.profileImageThumbImage!,
            largeImage: viewerInput?.userDetails?.profileImageLargeImage!,
        },
        preferences: {
            currency: viewerInput?.userDetails?.preferences?.currency!,
            currencySymbol: viewerInput?.userDetails?.preferences?.currencySymbol!,
            dateFormat: viewerInput?.userDetails?.preferences?.dateFormat!,
            language: viewerInput?.userDetails?.preferences?.language!,
            timeFormat: viewerInput?.userDetails?.preferences?.timeFormat!,
            timezone: viewerInput?.userDetails?.preferences?.timezone!,
            uiInfo: viewerInput?.userDetails?.preferences?.uiInfo!,
            isNotificationsEnabled: viewerInput?.userDetails?.preferences?.isNotificationsEnabled!,
        },
        metadata: viewerInput?.userDetails?.metadata!
            ? JSON.parse(viewerInput?.userDetails?.metadata!)
            : {},
        refreshToken: viewerInput?.userDetails?.refreshToken,
        // Added By Udit, added Fields, required by Aryan and Sachin.
        phoneNumber: viewerInput?.userDetails?.phoneNumber,
        passwordChangedOn: viewerInput?.userDetails?.passwordChangedOn,
        twoFactorAuth: viewerInput?.userDetails?.twoFactorAuth,
        birthDate: viewerInput?.userDetails?.birthDate,
        verifiedTelephones: viewerInput?.userDetails?.verifiedTelephones,
        telephones: viewerInput?.userDetails?.telephones,
    }
}
